import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/es";
import {
  IonButton,
  IonCol,
  IonGrid,
  IonIcon,
  IonLabel,
  IonRow,
} from "@ionic/react";

import {
  calendar,
  calendarOutline,
  close,
  closeOutline,
  print,
  printOutline,
} from "ionicons/icons";
import { DialogoConfirmacion } from "../../components/basicsComponents/DialogoConfirmacion/DialogoConfirmacion";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import {
  convertToPlain,
  obtenerNombreDia,
} from "../../utils/funcionalidadesStrings";
import ComprobanteTurno from "../../components/formComponents/ComprobanteTurno/ComprobanteTurno";
import {
  Column,
  Row,
} from "../../components/basicsComponents/MaterialGridComponents";
import { Card, Option, Select, Typography } from "@mui/joy";
import { LibraryAdd } from "@mui/icons-material";
import useTituloPagina from "../../hooks/tituloPagina";
import { esTelemedicina } from "../../utils/turnos";

export default function TurnosPaciente() {
  const [usuario, setUsuario] = useState({});
  const [cargando, setCargando] = useState(false);
  const [urlAxioPP, setUrlAxio] = useState("");
  const [tituloPagina, setTituloPagina] = useState("");
  const [servicios, setServicios] = useState([]);
  const [especialidades, setEspecialidades] = useState([]);
  const [prestadores, setPrestadores] = useState([]);
  const [estudios, setEstudios] = useState([]);
  const [listadoPrestadores, setListadoPrestadores] = useState([]);
  const [sedes, setSedes] = useState([
    { codigo: 1, text: "Central – Humberto Primo 546, Córdoba" },
    { codigo: 2, text: "Alta Córdoba – Juan Sarachaga 768, Córdoba" },
    {
      codigo: 3,
      text: "Villa Allende – Rio de Janeiro 137 Piso 2, Villa Allende",
    },
  ]);
  const [sedeSeleccionada, setSedeSeleccionada] = useState(-1);
  const [especialidadSeleccionada, setEspecialidadSeleccionada] = useState(-1);
  const [prestadorSeleccionado, setPrestadorSeleccionado] = useState(-1);
  const [filtroCancelados, setFiltroCancelados] = useState(-1);
  const [filtroAsistidos, setFiltroAsistidos] = useState(-1);
  const [listadoTurnos, setListadoTurnos] = useState([]);
  const [listadoTurnosFiltrados, setListadoTurnosFiltrados] = useState([]);
  const [turnoSeleccionado, setTurnoSeleccionado] = useState({});
  const [openReagendar, setOpenReagendar] = useState(true);
  const [turnoReagendar, setTurnoReagendar] = useState(null);
  const [abrirModalCancelarReserva, setAbrirModalCancelarReserva] =
    useState(false);
  const [abrirDesplegableAsistidos, setAbrirDeplegableAsistidos] =
    useState(false);
  const [abrirDesplegableCancelados, setAbrirDeplegableCancelados] =
    useState(false);
  const [abrirComprobanteTurno, setAbrirComprobanteTurno] = useState(false);
  const [cancelados, setCancelados] = useState([
    { codigo: true, text: "Cancelados" },
    { codigo: false, text: "No cancelados" },
  ]);
  const [asistidos, setAsistidos] = useState([
    { codigo: false, text: "No asistidos" },
    { codigo: true, text: "Asistidos" },
  ]);
  const [estadoTurnosFiltrados, setEstadoTurnosFiltrados] = useState(-1);
  const [expandedAcordeons, setExpandedAcordeons] = useState(new Set());

  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };
  const history = useHistory();
  useTituloPagina();

  /*const traerTurnosPaciente = async (paciente) => {
    let turnos = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      // Traer turnos activos
      const response = await axios.get(
        `${url}Turnos/TurnosPaciente/?paciente=${paciente.codigo}`,
        config
      );
      if (response.data.length !== 0) {
        turnos = response.data;
      }

      // Traer también los turnos cancelados (siempre, independientemente de si hay activos)
      const response2 = await axios.get(
        `${url}Turnos/TurnosPaciente/?paciente=${paciente.codigo}&Cancelado=true`,
        config
      );
      if (response2.data.length !== 0) {
        turnos = turnos.concat(response2.data);
      }

      // Si no hay turnos activos ni cancelados, entonces turnos será null
      setListadoTurnos(turnos.length > 0 ? turnos : null);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar consultar sus turnos registrados",
        "rojo"
      );
    }
  };*/
  const traerTurnosPaciente = async (paciente) => {
    let turnos = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      // Traer turnos activos
      const response = await axios.get(
        `${url}Turnos/TurnosPaciente/?paciente=${paciente.codigo}`,
        config,
      );
      if (response.data.length !== 0) {
        turnos = response.data;
      }
      console.log(turnos);
      // Traer también los turnos cancelados (siempre, independientemente de si hay activos)
      const response2 = await axios.get(
        `${url}Turnos/TurnosPaciente/?paciente=${paciente.codigo}&Cancelado=true`,
        config,
      );
      if (response2.data.length !== 0) {
        turnos = turnos.concat(response2.data);
      }
      console.log(turnos);
      turnos = turnos.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
      // Si no hay turnos activos ni cancelados, entonces turnos será null
      setListadoTurnos(turnos.length > 0 ? turnos : null);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar consultar sus turnos registrados",
        "rojo",
      );
    }
  };

  const traerEspecialidades = async (paciente, prestadoresDisponibles) => {
    let especialidades = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(`${url}Especialidades`, config);
      if (response.data.length !== 0) {
        especialidades = response.data;
      } else {
        especialidades = null;
      }

      especialidades = especialidades.filter(
        (especialidad) => especialidad.vigente === true,
      );

      //Obtenemos especialidades de los prestadores
      const especialidadesMostrables = [];
      prestadoresDisponibles.forEach((prestador) => {
        const valor = prestador.especialidad;
        if (!especialidadesMostrables.includes(valor)) {
          especialidadesMostrables.push(valor);
        }
      });
      //Buscamos especialidades de los prestadores entre todas las mutuales vigentes
      const especialidadesCoincidentes = [];
      especialidades.forEach((especialidad) => {
        if (especialidadesMostrables.includes(especialidad.codigo)) {
          especialidadesCoincidentes.push(especialidad);
        }
      });
      //Asignamos especialidades resultantes
      especialidades = especialidadesCoincidentes;

      especialidades = especialidades.map((especialidad) => {
        return {
          ...especialidad,
          text: especialidad.nombre,
        };
      });

      setEspecialidades(especialidades);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar consultar las especialidades registradas",
        "rojo",
      );
    }
  };

  const traerPrestadores = async (paciente) => {
    let prestadores = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(
        `${url}Prestadores?mutuales=${paciente.mutual}`,
        config,
      );
      if (response.data.length !== 0) {
        prestadores = response.data;
      } else {
        prestadores = null;
      }

      prestadores = prestadores.filter(
        (prestador) => prestador.vigente === true,
      );

      prestadores = prestadores.map((prestador) => {
        return {
          ...prestador,
          text: prestador.nombre,
          note2: prestador.domicilioTurno,
        };
      });
      return prestadores;
      setPrestadores(prestadores);
      setListadoPrestadores(prestadores);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar consultar los/las prestadores/as registradas",
        "rojo",
      );
    }
  };

  const traerEstudios = async (paciente) => {
    let estudios = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(`${url}Estudios`, config);
      if (response.data.length !== 0) {
        estudios = response.data;
      }

      estudios = estudios.map((estudio) => {
        return {
          ...estudio,
          text: estudio.nombre,
        };
      });

      setEstudios(estudios);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Se produjo un error al consultar l registradas en el sistema",
        "rojo",
      );
    }
  };

  const TraerServicio = async (paciente) => {
    try {
      let servicioResponse = {};
      const url = localStorage.getItem("urlAxioPP");
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };
      servicioResponse = await axios
        .get(`${url}Servicios`, config)
        .then((response) => {
          if (response.data.length !== 0) {
            return response.data;
          }
        });
      setServicios(servicioResponse);
    } catch (e) {}
  };

  const CargarDesplegables = async (sesion) => {
    await traerTurnosPaciente(sesion);
    let prestadoresDisponibles = await traerPrestadores(sesion);
    await traerEspecialidades(sesion, prestadoresDisponibles);
    await traerEstudios(sesion);
    await TraerServicio(sesion);
  };

  useEffect(() => {
    setCargando(true);
    try {
      const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
      if (sesion) {
        CargarDesplegables(sesion);
        setUsuario(sesion);
        setUrlAxio(localStorage.getItem("urlAxioPP"));
        setTituloPagina(localStorage.getItem("nombreClinica"));
        document.title = localStorage.getItem("tituloWeb");
      }
    } catch (e) {
      history.push({ pathname: "/ErrorPage" });
    }
    setCargando(false);
  }, []);

  const esTurnoEstudio = (turno) => {
    return Boolean(
      turno?.estudioNom ||
      turno?.equipoNom ||
      turno?.prestadorNom === "EQUIPOS" ||
      turno?.estudio,
    );
  };

  const obtenerPreparacionEstudio = (turno) => {
    const estudio = estudios.find(
      (estudioItem) => Number(estudioItem.codigo) === Number(turno.estudio),
    );

    return estudio?.preparacion || null;
  };

  const obtenerTituloTurno = (turno) => {
    if (esTurnoEstudio(turno)) {
      return turno.estudioNom || "Estudio de imagenes";
    }

    return `${turno.prestadorNom} - ${turno.especialidadNom}`;
  };

  const obtenerDetalleTurno = (turno) => {
    if (esTurnoEstudio(turno) && turno.equipoNom) {
      return `Equipo: ${turno.equipoNom}`;
    }

    return null;
  };

  const handleChangeSelect = (value, select) => {
    let especialidadSegunSede = -1;
    let edad = dayjs(dayjs()).diff(usuario.nacimiento, "year");

    switch (select) {
      case "Sede":
        switch (value) {
          case 1:
            if (edad < 17) {
              especialidadSegunSede = 107;
            } else {
              especialidadSegunSede = 98;
            }
            break;
          case 2:
            if (edad < 17) {
              especialidadSegunSede = 108;
            } else {
              especialidadSegunSede = 105;
            }
            break;
          case 3:
            if (edad < 17) {
              especialidadSegunSede = 109;
            } else {
              especialidadSegunSede = 106;
            }
            break;
          default:
            mostrarNotificacion(true, "Seleccion invalida", "rojo");
            break;
        }

        if (especialidadSegunSede !== -1) {
          setListadoPrestadores(
            prestadores.filter(
              (prestador) =>
                prestador.especialidad === especialidadSegunSede ||
                prestador.especialidad2 === especialidadSegunSede ||
                prestador.especialidad3 === especialidadSegunSede,
            ),
          );
        } else {
          setListadoPrestadores(prestadores);
        }
        setPrestadorSeleccionado(-1);
        setSedeSeleccionada(value);
        setEspecialidadSeleccionada(especialidadSegunSede);
        break;
      case "Especialidad":
        if (value !== -1) {
          switch (value) {
            case 98:
            case 107:
              especialidadSegunSede = 1;
              break;
            case 105:
            case 108:
              especialidadSegunSede = 2;
              break;
            case 106:
            case 109:
              especialidadSegunSede = 3;
              break;
            default:
              mostrarNotificacion(true, "Seleccion invalida", "rojo");
              break;
          }
          setListadoPrestadores(
            prestadores.filter((prestador) => prestador.especialidad === value),
          );
        } else {
          setListadoPrestadores(prestadores);
        }
        setPrestadorSeleccionado(-1);
        setSedeSeleccionada(especialidadSegunSede);
        setEspecialidadSeleccionada(value);
        break;
      case "Prestador":
        prestadores.map((prestador) => {
          if (prestador.codigo === value) {
            handleChangeSelect(prestador.especialidad, "Especialidad");
          }
        });
        setPrestadorSeleccionado(value);
        break;
      case "Cancelados":
        setFiltroCancelados(value);
        break;
      case "Asistidos":
        setFiltroAsistidos(value);
        break;
      default:
        mostrarNotificacion(true, "Seleccion invalida", "rojo");
        break;
    }
  };

  /*
  const CancelarTurno = async () => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${usuario.token}` },
      };

      let servicio = null;
      const serviciosResponse = await axios.get(
        `${urlAxioPP}Servicios`,
        config
      );

      if (serviciosResponse.data.length !== 0) {
        servicio = serviciosResponse.data[0];
      }

      if (servicio?.codigo !== null && turnoSeleccionado) {
        const cancelarTurnoResponse = await axios.patch(
          `${urlAxioPP}Turnos/Cancelar/${turnoSeleccionado.codigo}`,
          "",
          config
        );

        if (
          cancelarTurnoResponse.status === 200 &&
          cancelarTurnoResponse.statusText === "OK"
        ) {
          mostrarNotificacion(
            true,
            "El turno se cancelo correctamente",
            "verde"
          );
        } else {
          mostrarNotificacion(
            true,
            "Ocurrió un problema al intentar cancelar el turno",
            "rojo"
          );
        }
      }
    } catch ({ response }) {
      mostrarNotificacion(true, "Error: " + response.data, "rojo");
    }
  };*/
  const CancelarTurno = async () => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${usuario.token}` },
      };

      let servicio = null;
      const serviciosResponse = await axios.get(
        `${urlAxioPP}Servicios`,
        config,
      );

      if (serviciosResponse.data.length !== 0) {
        servicio = serviciosResponse.data[0];
      }

      if (servicio?.codigo !== null && turnoSeleccionado) {
        const cancelarTurnoResponse = await axios
          .patch(
            `${urlAxioPP}Turnos/Cancelar/${turnoSeleccionado.codigo}`,
            "",
            config,
          )
          .then(
            async () =>
              await axios.patch(
                `${urlAxioPP}Turnos/Quitar/${turnoSeleccionado.codigo}`,
                "",
                config,
              ),
          );

        if (
          cancelarTurnoResponse.status === 200 &&
          cancelarTurnoResponse.statusText === "OK"
        ) {
          mostrarNotificacion(
            true,
            "El turno se cancelo correctamente",
            "verde",
          );
        } else {
          mostrarNotificacion(
            true,
            "Ocurrió un problema al intentar cancelar el turno",
            "rojo",
          );
        }
      }
    } catch ({ response }) {
      mostrarNotificacion(true, "Error: " + response.data, "rojo");
    }
  };

  const FiltrarTurnos = () => {
    let listado = listadoTurnos || [];

    if (listado.length > 0) {
      if (especialidadSeleccionada !== -1) {
        listado = listado.filter(
          (turno) => especialidadSeleccionada === turno.especialidad,
        );
      }
      if (prestadorSeleccionado !== -1) {
        listado = listado.filter(
          (turno) => prestadorSeleccionado === turno.prestadorCod,
        );
      }
      if (filtroAsistidos !== -1) {
        listado = listado.filter((turno) => filtroAsistidos === turno.asistio);
      }
      if (filtroCancelados === true) {
        listado = listado.filter(
          (turno) => turno.aCancelar === false && turno.asistio === false,
        );
      } else if (filtroCancelados === false) {
        listado = listado.filter(
          (turno) =>
            turno.aCancelar === true ||
            (turno.aCancelar === false && turno.asistio === true),
        );
      }

      switch (estadoTurnosFiltrados) {
        case 0:
          listado = listado.filter((turno) => turno.asistio === true);
          break;
        case 1:
          listado = listado.filter(
            (turno) => turno.aCancelar === false && turno.asistio === false,
          );
          break;
        case 2:
          listado = listado.filter(
            (turno) => turno.aCancelar === true && turno.asistio === false,
          );
          break;
        default:
          break;
      }
    }

    setListadoTurnosFiltrados(listado);
  };

  useEffect(() => {
    FiltrarTurnos();
  }, [listadoTurnos, estadoTurnosFiltrados]);

  const togleAbrirCerrarCancelarReserva = () => {
    if (abrirModalCancelarReserva) {
      setTurnoSeleccionado({});
    }
    setAbrirModalCancelarReserva(!abrirModalCancelarReserva);
  };

  const handleClickSeleccionarTurno = (turno) => {
    setTurnoSeleccionado(turno);
    togleAbrirCerrarCancelarReserva();
  };

  const handleClickCancelarReserva = async () => {
    togleAbrirCerrarCancelarReserva();
    setCargando(true);
    await CancelarTurno();
    await traerTurnosPaciente(usuario);
    setCargando(false);
  };

  const togleAbrirCerrarComprobanteTurno = () => {
    if (abrirComprobanteTurno) {
      setTurnoSeleccionado({});
    }
    setAbrirComprobanteTurno(!abrirComprobanteTurno);
  };

  const handleClickComprobanteTurno = (turno) => {
    const prestadorEncontrado = prestadores.find(
      (prestador) => turno.prestadorCod === prestador.codigo,
    );
    const servicioEncontrado = servicios.find(
      (servicio) => servicio.codigo === turno.servicio,
    );
    const esImagen = esTurnoEstudio(turno);

    setTurnoSeleccionado({
      codigo: turno.codigo,
      equipoNom: turno.equipoNom,
      especialidadNom: turno.especialidadNom,
      estudioNom: turno.estudioNom,
      fecha: turno.fecha,
      hora: turno.hora,
      mutualNom: turno.mutualNom,
      prestadorNom: esImagen
        ? turno.equipoNom || turno.prestadorNom || "EQUIPOS"
        : turno.prestadorNom,
      servicio: turno.servicio,
      apellido: usuario.apellido,
      nombre: usuario.nombre,
      mutualNombre: usuario.mutualNombre,
      mutualAfiliado: usuario.mutualAfiliado,
      hc: usuario.hc,
      documentoTipoNombre: usuario.documentoTipoNombre,
      documentoNro: usuario.documentoNro,
      celular: usuario.celular,
      email: usuario.email,
      lugarAtencion:
        (prestadorEncontrado ? prestadorEncontrado.domicilioTurno : null) ||
        (servicioEncontrado ? servicioEncontrado.direccion : "") ||
        "",
      telemedicina: esTelemedicina(turno.telemedicina),
      preparacionEstudio: obtenerPreparacionEstudio(turno),
    });
    setAbrirComprobanteTurno(true);
  };

  const handleClickReservarTurno = (turno) => {
    if (esTurnoEstudio(turno)) {
      history.push({ pathname: "/portal/Reservar turno estudios" });
      return;
    }

    history.push({
      pathname: "/portal/Reservar turno",
      state: { prestador: turno.prestadorCod },
    });
  };

  const handleClickReagendarTurno = (turno) => {
    setTurnoReagendar({
      ...turno,
      nombre_profesional: turno.prestadorNom,
      idTramite: turno.codigo,
    });

    setTurnoSeleccionado(turno);
    setOpenReagendar(true);
  };

  const renderTurnosLista = (seePreviusVersion) => {
    return (
      <IonGrid
        className="tabla"
        style={{
          // border:
          //   "1px solid var(--ion-item-border-color, var(--ion-border-color, var(--ion-color-step-150, rgba(0, 0, 0, 0.13))))",
          margin: "10px",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        <IonIcon slot="start" md={calendar} ios={calendarOutline} />
        <Column className="" xs={12} marginBottom={1}>
          <Row>
            <Typography level="body-sm">Próximos turnos</Typography>
          </Row>
        </Column>
        {listadoTurnos.map((fila) => (
          <Card
            style={{ marginBottom: "7.5px", padding: "0px 14px" }}
            key={fila.codigo}
          >
            <Row
              className=""
              style={{ textAlign: "start" }}
              alignItems="center"
              container
            >
              <Column
                style={{ textAlign: "start" }}
                xs={6}
                md={8}
                lg={10}
                container
              >
                <Row alignItems="center" container>
                  <Column xs={12} md={6}>
                    <Typography level="title-sm" sx={{ color: "#B50009" }}>
                      {obtenerTituloTurno(fila)}
                    </Typography>
                  </Column>
                  <Column xs={12} md={6}>
                    <Typography level="title-sm">
                      {`${obtenerNombreDia(
                        dayjs(fila.fecha).format("dddd"),
                      )} ${dayjs(fila.fecha).format("DD")} de ${dayjs(
                        fila.fecha,
                      ).format("MMMM, YYYY")} a las ${dayjs(fila.hora).format(
                        "HH:mm",
                      )}`}
                    </Typography>
                    {obtenerDetalleTurno(fila) && (
                      <Typography level="body-sm">
                        {obtenerDetalleTurno(fila)}
                      </Typography>
                    )}
                  </Column>
                </Row>
                <Row className="" alignItems="center" container>
                  <Column xs={12} md={6}>
                    <Typography level="body-sm">{`${fila.mutualNom}`}</Typography>
                  </Column>
                  <Column xs={12} md={6}>
                    <Typography level="body-sm">{`Modalidad: ${
                      esTelemedicina(fila.telemedicina)
                        ? "Virtual"
                        : "Presencial"
                    }`}</Typography>
                  </Column>
                </Row>
                <Row className="" alignItems="center" container>
                  <Column xs={12} md={6}>
                    <Typography level="body-sm">{`Estado: ${
                      fila.asistio
                        ? "Asistido"
                        : fila.aCancelar
                          ? "Pendiente"
                          : "Cancelado"
                    }`}</Typography>
                  </Column>
                </Row>
                <Row className="" alignItems="center" container>
                  <Column xs={12}>
                    <Typography level="body-sm">
                      {obtenerPreparacionEstudio(fila)
                        ? convertToPlain(obtenerPreparacionEstudio(fila))
                        : null}
                    </Typography>
                  </Column>
                </Row>
              </Column>
              <Column container xs={6} md={4} lg={2}>
                <Row container>
                  {(dayjs().format("YYYY-MM-DD") !==
                    dayjs(fila.fecha).format("YYYY-MM-DD") ||
                    (dayjs().format("YYYY-MM-DD") ===
                      dayjs(fila.fecha).format("YYYY-MM-DD") &&
                      dayjs(fila.hora).format("HH:mm") >
                        dayjs().format("HH:mm"))) &&
                  fila.aCancelar ? (
                    <Column xs={12} container>
                      <IonButton
                        shape="roud"
                        fill="clear"
                        onClick={() => handleClickComprobanteTurno(fila)}
                        style={{ margin: "0px" }}
                      >
                        <IonIcon
                          aria-label="Cancelar turno"
                          ios={printOutline}
                          md={print}
                          style={{ color: "#B50009" }}
                        />
                        <IonLabel style={{ color: "#B50009" }}>
                          Comprobante
                        </IonLabel>
                      </IonButton>
                      <IonButton
                        shape="roud"
                        fill="clear"
                        onClick={() => handleClickSeleccionarTurno(fila)}
                        style={{ margin: "0px" }}
                      >
                        <IonIcon
                          aria-label="Cancelar turno"
                          ios={closeOutline}
                          md={close}
                          style={{ color: "#B50009" }}
                        />
                        <IonLabel style={{ color: "#B50009" }}>
                          Cancelar
                        </IonLabel>
                      </IonButton>
                    </Column>
                  ) : (
                    <Column className="" xs={12} container>
                      <IonButton
                        shape="roud"
                        fill="clear"
                        onClick={() => handleClickComprobanteTurno(fila)}
                        style={{ margin: "0px" }}
                      >
                        <IonIcon
                          aria-label="Cancelar turno"
                          ios={printOutline}
                          md={print}
                          style={{ color: "#B50009" }}
                        />
                        <IonLabel style={{ color: "#B50009" }}>
                          Comprobante
                        </IonLabel>
                      </IonButton>

                      <IonButton
                        shape="roud"
                        fill="clear"
                        onClick={() => handleClickReservarTurno(fila)}
                        style={{ margin: "0px" }}
                      >
                        <Typography level="title-sm" sx={{ color: "#B50009" }}>
                          {`Reservar turno`.toUpperCase()}
                        </Typography>
                        <LibraryAdd sx={{ color: "#B50009" }} />
                      </IonButton>
                    </Column>
                  )}
                </Row>
              </Column>
            </Row>
          </Card>
        ))}
      </IonGrid>
    );
  };

  return (
    <>
      {listadoTurnos === null || listadoTurnos.length <= 0 ? (
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            <IonCol>
              <div className="ion-text-center">
                <p>No tiene turnos registrados</p>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      ) : (
        <>
          {renderTurnosLista()}

          <DialogoConfirmacion
            titulo="Cancelar turno"
            texto={`Ha decidido cancelar el turno con ${
              esTurnoEstudio(turnoSeleccionado)
                ? turnoSeleccionado.estudioNom || "el estudio seleccionado"
                : `${turnoSeleccionado.prestadorNom}, con especialidad en ${turnoSeleccionado.especialidadNom}`
            }, para el dia ${obtenerNombreDia(
              dayjs(turnoSeleccionado.fecha).format("dddd"),
            )} ${dayjs(turnoSeleccionado.fecha).format("DD")} de ${dayjs(
              turnoSeleccionado.fecha,
            ).format("MMMM, YYYY")} a las ${dayjs(
              turnoSeleccionado.hora,
            ).format("HH:mm")}, ¿Esta seguro/a de ello?`}
            open={abrirModalCancelarReserva}
            setOpen={setAbrirModalCancelarReserva}
            handleClickConfirmar={handleClickCancelarReserva}
            colorBotonNo="danger"
            colorBotonSi="success"
            textoBotonNo="No"
            textoBotonSi="Si, cancelo"
          />

          <ComprobanteTurno
            turno={turnoSeleccionado}
            abrir={abrirComprobanteTurno}
            togleAbrirCerrarComprobanteTurno={togleAbrirCerrarComprobanteTurno}
            paciente={usuario}
          />
          <CustomToast
            openToast={toast.open}
            onDidDismiss={(e) => mostrarNotificacion(false, "", "")}
            message={toast.mensaje}
            colorNotificacion={toast.tipo}
          />
        </>
      )}
      {cargando && <LoadingBackdrop visualizar={cargando} />}
    </>
  );
}
